module.exports = __webpack_public_path__ + "puwenimg2.png?ec4cb603d2f7906cd1b35aeef1483635";